var pug = require("!../../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (enableGridFlexLayout, i18n, isForVNext, value) {if (value.EntityStatus) {
pug_html = pug_html + "\u003Cspan\u003E";
if (value.EntityStatus === 'Paused') {
pug_html = pug_html + "\u003Cdiv" + (" class=\"statuschangetask statusicondisplay statuschangehover clickable\""+" tabindex=\"0\""+pug.attr("id", `statusIcon${value.Id}`, true, true)+pug.attr("data-rowId", `${value.Id}`, true, true)+" data-statusText=\"Paused\""+pug.attr("aria-label", `${i18n.getString('EntityStatus_Paused')}`, true, true)+" role=\"button\"") + "\u003E";
if (value.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-paused-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusPaused_icon\"\u003E\u003C\u002Fdiv\u003E";
}
if (isForVNext && enableGridFlexLayout) {
pug_html = pug_html + "\u003Cdiv class=\"iconba iconba-ChevronDown\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else
if (value.EntityStatus === 'Draft') {
pug_html = pug_html + "\u003Cdiv" + (" class=\"statusicondisplay\""+pug.attr("id", `statusIcon${value.Id}`, true, true)+pug.attr("data-rowId", `${value.Id}`, true, true)+" data-statusText=\"Draft\""+pug.attr("aria-label", `${i18n.getString('EntityStatus_Draft')}`, true, true)+" role=\"button\"") + "\u003E";
if (value.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-paused-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusDraft_icon\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else
if (value.EntityStatus === 'Expired') {
if (isForVNext) {
pug_html = pug_html + "\u003Cdiv class=\"iconba iconba-Remove\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statushypendisplay\"\u003E" + (pug.escape(null == (pug_interp = ' - ') ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv" + (" class=\"statuschangetask statusicondisplay statuschangehover clickable\""+" tabindex=\"0\""+pug.attr("id", `statusIcon${value.Id}`, true, true)+pug.attr("data-rowId", `${value.Id}`, true, true)+" data-statusText=\"Enabled\""+pug.attr("aria-label", `${i18n.getString('EntityStatus_Active')}`, true, true)+" role=\"button\"") + "\u003E";
if (value.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-active-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusEnabled_icon\"\u003E\u003C\u002Fdiv\u003E";
}
if (isForVNext && enableGridFlexLayout) {
pug_html = pug_html + "\u003Cdiv class=\"iconba iconba-ChevronDown\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp));
}}.call(this,"enableGridFlexLayout" in locals_for_with?locals_for_with.enableGridFlexLayout:typeof enableGridFlexLayout!=="undefined"?enableGridFlexLayout:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"isForVNext" in locals_for_with?locals_for_with.isForVNext:typeof isForVNext!=="undefined"?isForVNext:undefined,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;